<template>
    <div class="col-md-3 spark-settings-tabs">
        
        <!-- Mobile nav toggle -->
        <div v-if="isMobileView" @click="toggleShowNav" class="mobile-nav">
            <div v-if="showNav" class="btn btn-success">
                <span class="mr-1">
                    <i class="fas fa-chevron-circle-up fa-lg"></i>
                </span>
                {{ titleForCurrentTab }}
            </div>
            <div v-else class="btn btn-success">
                <span class="mr-1">
                    <i class="fas fa-chevron-circle-down fa-lg"></i>
                </span>
                {{ titleForCurrentTab }}
            </div>
        </div>

        <div :class="[showNav || loadingProjects ? '' : 'd-none',  isMobileView && !loadingProjects ? 'mobile-nav pt-2 mb-4' : '']">
            <div v-show="loadingProjects" class="">
                <span class="fw-600">Loading projects...</span><span class="loader loader-sm float-right"></span>
            </div>
            <aside v-show="hasProjects">
                <transition-group name="list-completed" tag="ul" class="nav flex-column" @before-leave="beforeLeave">
                    <li key="project-dropdown" class="nav-item project-dropdown">
                        <div class="dropdown" :class="isMobileView ? 'mr-3' : ''">
                          <button v-bind:class="{ disabled: loadingProjects || !currentProject }" class="btn btn-light dropdown-toggle text-left" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span v-if="loadingProjects" class="text-muted"><span class="loader loader-sm float-left mr-3"></span>Loading</span>

                            <span v-else-if="currentProject">
                                {{ currentProject.name }}
                            </span>
                            <span v-else class="text-muted">
                                Projects will be listed here
                            </span>

                          </button>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" v-show="currentProject">
                            <div class="input-group mb-2">
                              <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">&#x1F50D;</span>
                              </div>
                              <input v-model="projectFilterInput" @input="projectFilterInputChanged" type="text" class="form-control" placeholder="Search" aria-label="project-filter" aria-describedby="basic-addon1">
                            </div>

                            <div v-for="project in filteredProjects" class="dropdown-item project-dropdown-link " :class="project.status != 'In progress' ? 'text-muted' : ''" @click="clickedProject(project)">{{ project.name }} <span v-if="project.status != 'In progress'" class="text-muted">({{ project.status }})</span></div>

                          </div>
                        </div>
                    </li>    

                    <li key='overview' class="nav-item " v-show="currentProject">
                        <a class="nav-link" href="#overview" aria-controls="overview" role="tab" data-toggle="tab">
                            <div v-if="loadingProjects != true">
                                <span class="nav-icon">
                                    <i class="fas fa-clipboard-list fa-lg"></i>
                                </span>Overview
                            </div>
                        </a>
                    </li>     

                    <li key='work-orders' class="nav-item " v-show="currentProject">
                        <a class="nav-link" href="#work-orders" aria-controls="work-orders" role="tab" data-toggle="tab">
                            <div v-if="loadingProjects != true">
                                <span class="nav-icon">
                                    <i class="fas fa-hammer fa-lg"></i>
                                </span>Work Orders
                            </div>
                        </a>
                    </li>

                    <li key='work-order-calendar' v-if="currentTab == 'work-orders' || currentTab == 'work-order-calendar'" class="nav-item nav-item-inset-level-1" v-show="currentProject">
                      <a class="nav-link nav-link-inset" href="#work-order-calendar" aria-controls="work-order-calendar" role="tab" data-toggle="tab">
                        <div v-if="loadingProjects != true">
                            Calendar
                        </div>
                      </a>
                    </li>

                    <li key='change-orders' class="nav-item " v-show="currentProject">
                        <a class="nav-link" href="#change-orders" aria-controls="change-orders" role="tab" data-toggle="tab">
                            <div v-if="loadingProjects != true">
                                <span class="nav-icon">
                                    <i class="fas fa-file-signature fa-lg"></i>
                                </span>Change Orders
                            </div>
                        </a>
                    </li>

                    <li key='selections' class="nav-item " v-show="currentProject">
                        <a class="nav-link" href="#selections" aria-controls="selections" role="tab" data-toggle="tab">
                            <div v-if="loadingProjects != true">
                                <span class="nav-icon">
                                    <i class="fas fa-paint-roller fa-lg"></i>
                                </span>Material Selections
                            </div>
                        </a>
                    </li>
                </transition-group>
            </aside>
        </div>
    </div>
</template>

<script>
    export default {

        props: ['role', 'user', 'team'],

        mixins: [require('../../../mixins/tab-state')],

        created: function() {

            window.addEventListener("resize", this.updateWindowSize);
            this.updateWindowSize();

            // Gracefully handle tab changes
            let vm = this;

            Bus.$on('sparkHashChanged', function (hash, parameters) {
                vm.currentTab = hash;

                // Required to re-register the animated tabs now visible
                vm.$nextTick(() => {
                    vm.registerTabClickHandler();
                });

                // Hide the nav "dropdown" upon click
                if (vm.isMobileView && vm.showNav) {
                    vm.showNav = false;
                }

                return true;
            });

            Bus.$on('project-updated', function (response) {
                vm.projectUpdated(response);
                return true;
            });

            Bus.$on('set-current-project', function (project) {
                vm.currentProject = project;
            });

            Bus.$on('project-created', function (project) {
                vm.refresh();
                $('a[href="#projects"]').trigger('click');
            });

            Bus.$on('project-deleted', function (project) {
                vm.refresh();
                $('a[href="#projects"]').trigger('click');
            });

            //if somebody manually types it in:
            $(window).bind('hashchange', function() {
                vm.activateTabForCurrentHash(); 
            });

            this.getProjects();
        },

        destroyed() {
            window.removeEventListener("resize", this.updateWindowSize);
        },

        mounted: function() {
            this.usePushStateForTabs('.spark-settings-tabs');
        },

        data: function() {
            return {
                windowSize: 768,
                currentTab: '',
                projects:[],
                activeProjects: [],
                filteredProjects:[],
                loadingProjects: true,
                projectFilterInput: '',
                currentProject: null,
                showNav: !this.isMobileView,
                navMap: {
                    'projects' : 'Projects',
                    'crew' : 'Team members',
                    'add-crew-member' : 'Add team member',
                    'overview' : 'Overview',
                    'customer' : 'Projects',
                    'work-orders' : 'Work orders',
                    'work-order-calendar' : 'Work order calendar',
                    'change-orders' : 'Change orders',
                    'selections' : 'Material selections',
                }
            };
        },

        watch: {
            loadingProjects: function(newVal, oldVal) {
                Bus.$emit('projects-loading-status', newVal);
            },

            showOnboarding: function(newVal, oldVal) {
                Bus.$emit('show-welcome-message', newVal);
            },

            projects: function(newVal, oldVal) {
                Bus.$emit('has-projects', newVal.length > 0);
            },

            windowSize: function(newVal, oldVal) {
                if (!this.isMobileView) {
                    this.showNav = true;
                }
            },
        },

        computed: {
            showOnboarding: function() {
                return !this.loadingProjects && this.projects.length == 0;
            },

            hasProjects: function() {
                return this.projects.length > 0;
            },

            isMobileView: function() {
                return this.windowSize < 768;
            },

            titleForCurrentTab: function() {
                return this.navMap[this.currentTab];
            },
        },

        methods: {

            updateWindowSize: function() {
                this.windowSize = window.innerWidth;
            },

            toggleShowNav: function() {
                this.showNav = !this.showNav;
            },

            projectUpdated: function(updatedProject) {
                for (var index in this.projects) {
                    var project = this.projects[index];
                    if (project.id == updatedProject.id) {
                        // Use Vue.set to get reactivity when changing the contents of an array
                        Vue.set(this.projects, this.projects.indexOf(project), updatedProject);
                        break;
                    }
                }
                this.loadActiveProjects();
                if (this.activeProjects.length == 0) {
                    $('a[href="#projects"]').trigger('click');
                }
            },

            // Required for smooth nav updates
            beforeLeave(el) {
                const {marginLeft, marginTop, width, height} = window.getComputedStyle(el)
                el.style.left = `${el.offsetLeft - parseFloat(marginLeft, 10)}px`
                el.style.top = `${el.offsetTop - parseFloat(marginTop, 10)}px`
                el.style.width = width
                el.style.height = height
            },

            loadActiveProjects: function() {
                //this.activeProjects = _.fxilter(this.projects, project => { return project.status === "In progress" } );
                //
                // March 4: For now, just list all Projects, sorted by last updated. People may want to create work orders/etc 
                // before marking as "In progress"
                // TODO: Add a filter for the dropdown.
                //
                this.activeProjects = this.projects;
                this.filteredProjects = this.activeProjects;
                if (this.filteredProjects.length > 0) {
                    this.currentProject = this.activeProjects[0];
                }
                else {
                    this.currentProject = null;
                }
                this.updateCurrentProject(this.currentProject);
            },

            getProjects: function() {
                //this.projects = [];
                axios.get(`/api/projects`)
                    .then(response => {
                        this.loadingProjects = false;
                        this.error = false;
                        this.projects = response.data;
                        this.loadActiveProjects();
                    })
                    .catch(error => {
                       this.loadingProjects = false;
                       this.error = true;
                    });
            },

            clickedProject: function(project) {
                this.updateCurrentProject(project);
            },

            updateCurrentProject: function(project) {
                Bus.$emit('set-current-project', project);
            },

            projectFilterInputChanged: function() {
                // Cleared search?
                if (this.projectFilterInput.length < 1) {
                    this.filteredProjects = this.activeProjects;
                    return;
                }

                var filteredProjects = [];
                var regexQuery = new RegExp(this.projectFilterInput, 'i');

                //Filter locally through our projects
                for (var i = 0; i < this.activeProjects.length; i++) {
                  var project = this.activeProjects[i];

                  //Search for name
                  var match = regexQuery.test(project.name);
                  if (match) {
                    filteredProjects.push(project);
                    continue;
                  }
                }

                this.filteredProjects = filteredProjects;
            },

            refresh: function() {
                this.projectFilterInput = '';
                this.getProjects();
            }
        }
    }
</script>
